module.exports = __webpack_public_path__ + "img/blank connect 4 piece.910037e4.png";